import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Experiences from "@/pages/Experiences";
import Destinations from "@/pages/Destinations";
import Wellness from "@/pages/Wellness";
import Partnership from "@/pages/Partnership";
import Itineraries from "@/pages/Itineraries";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import TravelInfo from "@/pages/TravelInfo";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
          <SmoothScroll>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/experiences" element={<Experiences />} />
                <Route path="/destinations" element={<Destinations />} />
                <Route path="/wellness" element={<Wellness />} />
                <Route path="/partnership" element={<Partnership />} />
                <Route path="/itineraries" element={<Itineraries />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/travel-info" element={<TravelInfo />} />
              </Routes>
            </Layout>
          </SmoothScroll>
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
